import api from './api';

export async function fetchSyncProtocolTemplates(params = {}) {
  const res = await api.get('/sync-protocol-templates', {
    params: { paginate: false, ...params },
  });
  return res.data?.data || [];
}

export async function fetchSyncProtocolTemplate(id) {
  const res = await api.get(`/sync-protocol-templates/${id}`);
  return res.data;
}

export async function createSyncProtocolTemplate(payload) {
  const res = await api.post('/sync-protocol-templates', payload);
  return res.data;
}

export async function updateSyncProtocolTemplate(id, payload) {
  const res = await api.put(`/sync-protocol-templates/${id}`, payload);
  return res.data;
}

export async function deleteSyncProtocolTemplate(id) {
  await api.delete(`/sync-protocol-templates/${id}`);
}
